/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlProvider } from '@api/external-transfer';
import { LoggingService } from '@shared/logging';
import { catchError, combineLatest, first, Observable, switchMap, throwError } from 'rxjs';
import { ApiErrorModel } from './models/api-error.model';
import { ApiKeyProviderService } from './api-key-provider.service';

@Injectable({ providedIn: 'root' })
export class HttpService {
	public constructor(
		private http: HttpClient,
		private loggingService: LoggingService,
		private apiUrlProvider: ApiUrlProvider,
		private apiKeyProivderService: ApiKeyProviderService
	) {}

	public get<T>(connectionId: string, endpoint: string): Observable<T> {
		// todo: use shareReplay to avoid maiking calls to db, keep in mind to reset when changing workfile
		return this.getConnectionUrlAndApiKey$(connectionId).pipe(
			first(),
			switchMap((result) => {
				const headers = this.setHeaders(result.apiKey);
				return this.http.get<T>(`${result.connectionUrl}${endpoint}`, { headers, withCredentials: false }).pipe(
					catchError((error: ApiErrorModel) => {
						this.loggingService.error(`Call failed for request ${endpoint}`, error.errorMessage);
						return throwError(() => error);
					})
				);
			})
		);
	}

	public post<T, K>(connectionId: string, endpoint: string, object: T): Observable<K> {
		// todo: use shareReplay to avoid maiking calls to db, keep in mind to reset when changing workfile
		
		return this.getConnectionUrlAndApiKey$(connectionId).pipe(
			first(),
			switchMap((result) => {
				const headers = this.setHeaders(result.apiKey);
				console.log("CHECKIN HERE result", result, connectionId);
				console.log("CHECKIN HERE object", object,)
				return this.http
					.post<K>(`${result.connectionUrl}/${endpoint}`, object, { withCredentials: false, headers })
					.pipe(
						catchError((error: ApiErrorModel) => {
							this.loggingService.error(`Call failed for request ${endpoint}`, error.errorMessage);
							console.log("CHECKIN HERE Error", error, object);
							return throwError(() => error);
							
						})
					);
			})
		);
	}

	private setHeaders(apiKey: string): HttpHeaders {
		const headers = apiKey
			? new HttpHeaders({
					Accept: 'application/json',
					'Content-Type': 'application/json',
					'Ocp-Apim-Subscription-Key': apiKey
			  })
			: new HttpHeaders({
					Accept: 'application/json',
					'Content-Type': 'application/json'
			  });

		return headers;
	}

	private getConnectionUrlAndApiKey$(connectionId: string): Observable<{ connectionUrl: string; apiKey: string }> {
		return combineLatest({
			connectionUrl: this.apiUrlProvider.getUrl$(connectionId),
			apiKey: this.apiKeyProivderService.get$(connectionId)
		});
	}
}
